import { useMemo } from "react";

import {
  DraggableItem,
  DroppableItem,
} from "@smart/itops-sb-design-system-dom";

import { FieldComponent } from "./field-component";
import {
  fieldComponentContainerDroppableId,
  fieldComponentDraggableIdPrefix,
  fieldComponentGroups,
} from "../constants";
import { FieldTemplate } from "../types";

type FieldComponentsProps = {
  disabled?: boolean;
  excluding?: FieldTemplate[];
};

const FieldComponents = ({ disabled, excluding }: FieldComponentsProps) => {
  const filteredFieldComponentGroups = useMemo(
    () =>
      fieldComponentGroups
        .map((g) => ({
          ...g,
          components: g.components.filter(
            (c) => !excluding?.some((e) => e.type === c.type),
          ),
        }))
        .filter((g) => g.components.length > 0),
    [excluding],
  );

  return (
    <div className="w-[25.6rem] py-[1.6rem] overflow-auto border-neutral-100 border-l border-solid">
      <h2 className="text-paragraph font-semibold font-poppins pl-[2.4rem] mb-[1.6rem]">
        Components
      </h2>
      <div className="border-t border-neutral-100 my-[1.6rem]" />
      <DroppableItem
        className="flex flex-col gap-medium px-[0.8rem]"
        id={fieldComponentContainerDroppableId}
      >
        {() =>
          filteredFieldComponentGroups.map(({ name, components }) => (
            <div className="flex flex-col gap-small" key={name}>
              <h3 className="text-ui text-neutral-600 font-semibold pl-[1.6rem]">
                {name}
              </h3>
              <div className="flex flex-col gap-small">
                {components.map((template) => (
                  <DraggableItem
                    key={template.type}
                    id={`${fieldComponentDraggableIdPrefix}-${template.type}`}
                    fixItemPosition
                    disabled={disabled}
                  >
                    {({ dragHandleProps, isDragging }) => (
                      <div
                        {...dragHandleProps.attributes}
                        {...dragHandleProps.listeners}
                      >
                        <FieldComponent
                          type={template.type}
                          isDragging={isDragging}
                          disabled={disabled}
                        />
                      </div>
                    )}
                  </DraggableItem>
                ))}
              </div>
            </div>
          ))
        }
      </DroppableItem>
    </div>
  );
};

export { FieldComponents };
